import { render, staticRenderFns } from "./ReportBillingRemovals.vue?vue&type=template&id=2db7a2a6"
import script from "./ReportBillingRemovals.vue?vue&type=script&lang=js"
export * from "./ReportBillingRemovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports